import React from "react";
import classnames from "classnames";
import { TFunction } from "i18next";

type Props = {
    isDisabled: boolean;
    isFidelityArchived: boolean;
    onClick: () => void;
    t: TFunction;
};

export default function BulkArchiveMenuItem({
    isDisabled,
    isFidelityArchived,
    onClick,
    t,
}: Props) {
    return (
        <div
            style={{ cursor: "pointer" }}
            className={classnames("dropdown-item pl-1 pointer__clz", {
                "not-allowed-icon__clz": isDisabled,
            })}
            onClick={onClick}
        >
            <span className="ml-2 cmn_btn_BTarchived cmn_btn_BTunarchive">
                {isFidelityArchived ? t("unarchive") : t("archive")}
            </span>
        </div>
    );
}
